import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';

import './CommonPopup.css';

const CommonPopup = (props) => {
  const {
    className,
    triggerClassName,
    children,
    content,
    trigger,
    questionIcon,
    infoIcon,
    errorIcon,
    successIcon,
    type,
    visibleBy,
  } = props;

  const renderTrigger = () => {
    if (questionIcon) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M6 0C2.687 0 0 2.684 0 5.997a6 6 0 1011.999 0A5.997 5.997 0 006 0zm.427 9.335a.706.706 0 01-.484.186.733.733 0 01-.495-.183c-.141-.123-.212-.294-.212-.515a.693.693 0 01.707-.692c.196 0 .36.066.494.199.133.134.2.298.2.493 0 .218-.07.388-.21.512zm1.738-4.308c-.107.199-.234.37-.382.515a27.09 27.09 0 01-.793.727c-.106.097-.19.181-.253.254a.961.961 0 00-.215.382c-.016.06-.042.166-.077.318-.058.323-.243.484-.553.484a.568.568 0 01-.407-.158c-.11-.105-.165-.262-.165-.47 0-.26.04-.486.121-.677.08-.191.188-.358.321-.502a6.94 6.94 0 01.54-.514c.198-.174.342-.305.43-.393.089-.089.163-.187.223-.296a.706.706 0 00.091-.353.818.818 0 00-.277-.628c-.185-.171-.423-.256-.714-.256-.342 0-.593.086-.754.258-.161.172-.297.426-.409.761-.106.35-.306.525-.6.525a.59.59 0 01-.44-.183.56.56 0 01-.179-.398c0-.295.095-.593.284-.896a2.18 2.18 0 01.828-.751c.363-.199.786-.298 1.27-.298.449 0 .846.083 1.191.249.344.166.61.392.798.677.187.285.281.596.281.93.001.264-.053.495-.16.693z" fill="#E0E4EE"/></svg>
      );
    }
    if (infoIcon) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path d="M6.5 13a6.5 6.5 0 110-13 6.5 6.5 0 010 13zm0-11.818a5.318 5.318 0 100 10.636 5.318 5.318 0 000-10.636zm0 4.071a1.134 1.134 0 110-2.269 1.134 1.134 0 010 2.269zm.873 4.76H5.627V6.117h1.746v3.896z" fill="#9297B7"/></svg>
      );
    }
    if (errorIcon) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path d="M6 0a6 6 0 110 12A6 6 0 016 0z" fill="#F67261"/><path d="M7.172 6l1.493 1.493c.382.382.431.955.107 1.279-.324.324-.897.276-1.28-.107L5.999 7.172 4.507 8.665c-.383.382-.955.43-1.279.106-.324-.323-.276-.896.107-1.279l1.492-1.493-1.492-1.492c-.383-.383-.431-.956-.107-1.279.324-.324.896-.276 1.279.107l1.492 1.492 1.493-1.493c.383-.383.956-.43 1.28-.107.324.324.275.897-.107 1.28L7.172 6z" fill="#FFF"/></svg>
      );
    }
    if (successIcon) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path d="M6 0a6 6 0 110 12A6 6 0 016 0z" fill="#20D263"/><path d="M4.923 8.994L1.999 6.258l1.078-1.036 1.769 1.701 4.078-3.92 1.077 1.035-5.078 4.956z" fill="#FFF"/></svg>
      );
    }
    return trigger;
  };

  return (
    <Popup
      className={`common-popup__component ${className} ${type}`}
      trigger={
        <div className={`common-popup__component-trigger ${triggerClassName}`}>
          {renderTrigger()}
        </div>}
      content={content}
      basic
      hideOnScroll
      wide="very"
      on={visibleBy}
    >
      {children}
    </Popup>
  );
};


CommonPopup.propTypes = {
  className: PropTypes.string,
  triggerClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.object]),
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.object]),
  questionIcon: PropTypes.bool,
  infoIcon: PropTypes.bool,
  errorIcon: PropTypes.bool,
  successIcon: PropTypes.bool,
  visibleBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
CommonPopup.defaultProps = {
  className: '',
  triggerClassName: '',
  children: null,
  content: null,
  type: 'info',
  trigger: null,
  questionIcon: null,
  infoIcon: null,
  errorIcon: null,
  successIcon: false,
  visibleBy: ['click', 'hover'],
};

export default CommonPopup;
